import {
  DEFAULT_EGG_LIGHTS,
  DEFAULT_EGG_REDSHIFT,
  DEFAULT_EGG_TRANSFORM,
  DEFAULT_EGG_WARMTH,
  DEFAULT_MARC_TRANSFORM,
  DEFAULT_PALETTE,
} from "../constants";

// Merges sources of truth into a single "effective" bag used by the
// drawing surface.
//
//   Author mode: author state always wins; reference.json is ignored.
//                localStorage-backed values give the author's iteration
//                state refresh-survival between sessions.
//
//   Play mode:   reference.json + hard defaults ONLY. The author's
//                localStorage is never consulted in play mode — if the
//                values aren't in the committed reference, the marc
//                renders with defaults. This is deliberate: fresh
//                checkouts and other machines must render the same as
//                the author's, so we never let local-only state mask a
//                "this marc hasn't been saved yet" bug.
export default function useEffectiveReferenceValues({
  authorMode,
  reference,
  author,
}) {
  if (authorMode) {
    return {
      palette: author.palette,
      eggTransform: author.eggTransform,
      eggLights: author.eggLights,
      eggWarmth: author.eggWarmth,
      eggRedshift: author.eggRedshift,
      marcTransform: author.marcTransform,
    };
  }

  const palette =
    reference?.palette?.length === DEFAULT_PALETTE.length
      ? reference.palette
      : DEFAULT_PALETTE;
  const eggTransform = reference?.egg?.transform ?? DEFAULT_EGG_TRANSFORM;
  const eggLights = reference?.egg?.lights ?? DEFAULT_EGG_LIGHTS;
  const eggWarmth = reference?.egg?.warmth ?? DEFAULT_EGG_WARMTH;
  const eggRedshift = reference?.egg?.redshift ?? DEFAULT_EGG_REDSHIFT;
  const marcTransform = reference?.marc?.transform ?? DEFAULT_MARC_TRANSFORM;

  return {
    palette,
    eggTransform,
    eggLights,
    eggWarmth,
    eggRedshift,
    marcTransform,
  };
}
